module.exports = __webpack_public_path__ + "windowsHello_ico@2x.1d4b9d126f31537fbcce742c1941fedf.png";